import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogTitle, Grid, IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { uwinAPI } from '../../../../services/uwin.api';
import { toast } from 'react-toastify';

const ViewPregnancyDetails = (props) => {
    const { isModalOpen, isModalClose, pregnancyDetails } = props;
    const [pregnancyDetailsData, setPregnancyDetailsData] = useState([]);

    useEffect(() => {
        fetchPregnancyDetails();
    }, [pregnancyDetails]);

    const fetchPregnancyDetails = async () => {
        const payload = {
            beneficiary_id: pregnancyDetails?.beneficiary_id,
            pregnancy_number: pregnancyDetails?.pregnancy_number
            
        }

        try {
            const response = await uwinAPI.getPregnancyDetailsByPrgId(payload);

            if (response?.success) {
                setPregnancyDetailsData(response?.data?.[0]);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };

    return (
        <Dialog
            open={isModalOpen}
            onClose={isModalClose}
            maxWidth="md"
            fullWidth
            PaperProps={{ sx: { borderRadius: "16px" } }}
        >
            <DialogTitle>
                View Pregnancy Details
                <IconButton
                    onClick={isModalClose}
                    sx={{ position: "absolute", right: 16, top: 16 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ px: 4, pb: 4 }} dividers>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <h6 className='viewHead dark'>BASIC DETAILS</h6>
                    </Grid>
                    <Grid size={3}>
                        <h6 className="viewHead">LMP Date</h6>
                        <p className="viewData">{pregnancyDetailsData?.lmc_date}</p>
                    </Grid>
                    <Grid size={3}>
                        <h6 className="viewHead">Blood Group</h6>
                        <p className="viewData">{pregnancyDetailsData?.blood_group}</p>
                    </Grid>
                    <Grid size={6}>
                        <h6 className="viewHead">DATE OF LAST PREGNANCY OUTCOME</h6>
                        <p className="viewData">{pregnancyDetailsData?.previous_pregnancy_year}</p>
                    </Grid>
                    <Grid size={12}>
                        <div className="d-flex">
                            <h6 className="viewHead dark">PREGNANCY OUTCOME</h6>
                            <h6 className="viewHead"> | {pregnancyDetailsData?.pregnancyOutcomeDetails?.type}</h6>
                        </div>
                    </Grid>
                    <Grid size={3}>
                        <h6 className="viewHead">DATE OF DELIVERY</h6>
                        <p className="viewData">{pregnancyDetailsData?.pregnancyOutcomeDetails?.date_of_delivery}</p>
                    </Grid>
                    <Grid size={3}>
                        <h6 className="viewHead">PLACE OF DELIVERY</h6>
                        <p className="viewData">{pregnancyDetailsData?.pregnancyOutcomeDetails?.place_of_delivery}</p>
                    </Grid>
                    <Grid size={3}>
                        <h6 className="viewHead">WHO CONDUCTED DELIVERY</h6>
                        <p className="viewData">{pregnancyDetailsData?.pregnancyOutcomeDetails?.who_conducted_delivery}</p>
                    </Grid>
                    <Grid size={3}>
                        <h6 className="viewHead">TYPE OF DELIVERY</h6>
                        <p className="viewData">{pregnancyDetailsData?.pregnancyOutcomeDetails?.type_of_delivery}</p>
                    </Grid>

                    {pregnancyDetailsData?.pregnancyOutcomeDetails?.live_birth?.length < 0 &&
                        pregnancyDetailsData?.pregnancyOutcomeDetails?.live_birth.map((child, index) => (
                            <React.Fragment key={index}>

                                <Grid size={12}>
                                    <h6 className="viewHead divider dark">CHILD DETAILS</h6>
                                </Grid>

                                <Grid size={3}>
                                    <h6 className="viewHead">NAME OF THE CHILD</h6>
                                    <p className="viewData">{child?.child_name}</p>
                                </Grid>

                                <Grid size={3}>
                                    <h6 className="viewHead">GENDER</h6>
                                    <p className="viewData">{child?.child_gender}</p>
                                </Grid>

                                <Grid size={3}>
                                    <h6 className="viewHead">BIRTH WEIGHT</h6>
                                    <p className="viewData">{child?.child_weight}</p>
                                </Grid>

                                <Grid size={3}>
                                    <h6 className="viewHead">FATHER NAME</h6>
                                    <p className="viewData">{child?.father_name}</p>
                                </Grid>

                                <Grid size={4}>
                                    <h6 className="viewHead">BABY CRIED IMMEDIATELY AFTER BIRTH</h6>
                                    <p className="viewData">{child?.baby_cried_immediately_after_birth === true ? "Yes" : "No"}</p>
                                </Grid>

                                <Grid size={4}>
                                    <h6 className="viewHead">BREAST FEEDING STARTED WITHIN 1 HOUR</h6>
                                    <p className="viewData">
                                        {child?.breastfeeding_started_within_hour === true ?
                                            "Yes"
                                            : `No | Reason: ${child?.breastfeeding_started_within_hour_other_reason || "-"}`
                                        }
                                    </p>
                                </Grid>

                                <Grid size={4}>
                                    <h6 className="viewHead">ANY BIRTH VISIBLE DEFECTS</h6>
                                    <p className="viewData">
                                        {child?.birth_visible_defects === true
                                            ? `Yes | Reason: ${child?.birth_visible_defects_reason?.join(", ") || "-"}`
                                            : "No"
                                        }
                                    </p>
                                </Grid>

                            </React.Fragment>
                        ))}
                </Grid>
            </DialogContent>
        </Dialog >
    )
}

export default ViewPregnancyDetails